export default function parseUserData({ agent, email, signupState, sudoer }) {
  return {
    ...agent,
    signupState,
    email,
    isSudoFromAdmin: Boolean(Object.keys(sudoer).length),
    isAdvertisementAdmin:
      sudoer.permissions && sudoer.permissions.sudoPishkhanAds,
  };
}
